import { render, staticRenderFns } from "./FormatedIcon.vue?vue&type=template&id=fc06b5b2&scoped=true"
import script from "./FormatedIcon.vue?vue&type=script&lang=js"
export * from "./FormatedIcon.vue?vue&type=script&lang=js"
import style0 from "./FormatedIcon.vue?vue&type=style&index=0&id=fc06b5b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc06b5b2",
  null
  
)

export default component.exports